module.exports = __webpack_public_path__ + "static/media/mail_grey_icon.2396677c.svg";